import { render, staticRenderFns } from "./TaskChangeClosure.vue?vue&type=template&id=44a09a7e&scoped=true&lang=pug&"
import script from "./TaskChangeClosure.vue?vue&type=script&lang=js&"
export * from "./TaskChangeClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a09a7e",
  null
  
)

export default component.exports